import api from "../../../services/api"
import axios from "axios"
import Baseurlaxios from "../../../services/baseurlaxios"

import { toastr } from "react-redux-toastr"

// let UltCodPuxada;
// let UltTipoBusca;
// let UltCodVnd;
// let UltStrUF;
// let UltStrCdd;
// let UltStrBairro;
// let UltCodCetIni;
// let UltCodCetFim;
// let UltOpcSomenteUm;

export function GetCustumerUF(CodPuxada) {
    return (dispatch) => {
        api.get(`/Customer/BuscaCustomerUF?CodPuxada=${CodPuxada}&UF=True`
        )
            .then(response => {
                dispatch({
                    type: "GET_UF",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro custumerActions GetCustumerUF: " + error)
            })
    }
}

export function GetCustumerUFCid(CodPuxada) {
    return (dispatch) => {
        api.get(`/Customer/BuscaCustomerUFCid?CodPuxada=${CodPuxada}&UF=true&Cid=true`
        )
            .then(response => {
                dispatch({
                    type: "GET_CIDUF",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro custumerActions GetCustumerUFCid: " + error)
            })
    }
}

export function GetCustumerEnd(CodPuxada) {
    return (dispatch) => {
        api.get(`/Customer/BuscaCustomerEnderecos?CodPuxada=${CodPuxada}&End=true`
        )
            .then(response => {
                dispatch({
                    type: "GET_ENDERECOS",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro custumerActions GetCustumerEnd: " + error)
            })
    }
}

export function GetCustumerVnd(CodPuxada) {
    return (dispatch) => {
        api.get(`/Customer/BuscaCustomerVendedores?CodPuxada=${CodPuxada}&Vnd=0`
        )
            .then(response => {
                dispatch({
                    type: "GET_VENDEDORES",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro custumerActions GetCustumerVnd: " + error)
            })
    }
}

// TipoBusca 1 = Vendedor
// TipoBusca 2 = Endereco
// TipoBusca 3 = Cod CLi Ini - Fim
// TipoBusca 4 = Todos
export function GetCustumerTodosCet(CodPuxada, TipoBusca, CodVnd
    , StrUF, StrCdd, StrBairro, CodCetIni, CodCetFim, OpcSomenteUm) {

    //  UltCodPuxada = CodPuxada
    //  UltTipoBusca = TipoBusca
    //  UltCodVnd  = TipoBusca
    //  UltStrUF = CodVnd
    //  UltStrCdd = StrCdd
    //  UltStrBairro = StrBairro
    //  UltCodCetIni = CodCetIni
    //  UltCodCetFim = CodCetFim
    //  UltOpcSomenteUm = OpcSomenteUm


    return (dispatch) => {
        api.get(`/Customer/BuscaCustomerTodosCet?CodPuxada=${CodPuxada}&TipoBusca=${TipoBusca}&CodVnd=${CodVnd}&StrUF=${StrUF}&StrCdd=${StrCdd}&StrBairro=${StrBairro}&CodCetIni=${CodCetIni}&CodCetFim=${CodCetFim}`
        )
            .then(response => {
                if (OpcSomenteUm === false) {
                    dispatch({
                        type: "GET_TODOSCET",
                        payload: response
                    })
                } else {
                    dispatch({
                        type: "GET_DATA_INFORMACOES",
                        payload: response
                    })
                }
            })
            .catch(error => {
                toastr.error("Erro custumerActions GetCustumerTodosCet: " + error)
            })
    }
}

export function getDataTdsRevendas() {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/Tb_Dist/TodosDist`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_LSTRVD",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro custumerActions getDataTdsRevendas: " + error)
            })
    };
}

export function getDataDelivery(CodPuxada, resellerID, codcet) {
    return (dispatch) => {
        api.get(`/Customer/DadosDelivery?CodPuxada=${CodPuxada}&resellerID=${resellerID}&codcet=${codcet}`
       )
            .then(response => {
                dispatch({
                    type: "GET_DATA_DELIVERY",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro custumerActions getDataDelivery: " + error)
            })
    };
}

export function getDataFinancial(CodPuxada, resellerID, codcet) {
    return (dispatch) => {
        api.get(`/Customer/DadosFinancial?CodPuxada=${CodPuxada}&resellerID=${resellerID}&codcet=${codcet}&CtrFin=false`
        )
            .then(response => {
                dispatch({
                    type: "GET_DATA_FINANCIAL",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro custumerActions getDataFinancial: " + error)
            })
    };
}

export function enviaRegistros(arraycodCet, codpuxada, usuario, Opcao, LstCetSel) {

    return (dispatch) => {
        api.post(`/Tb_Log_Envio_Custumers/IncluiLogCustumers?CodPuxada=${codpuxada}&Usuario=${usuario}&Opcao=${Opcao}`, {
            "ArrayCodCet": arraycodCet
        }
        )
            .then(response => {
                if (response.status === 200) {
                    // toastr.success("Enviada a solicitação com sucesso, o será realizado em fila processamentos")
                }
                else {
                    toastr.warning("Reposta da API: " + response.data)
                }

                // dispatch([
                //     teste(LstCetSel)
                // ])
            })
            .catch(error => {
                toastr.error("Erro custumerActions enviaRegistros: " + error.statusText)
            })
    }
}

// export function teste(arrayrecebido) {
//     return (dispatch) => {
//         dispatch({
//             type: "GET_RECARREGA",
//             payload: arrayrecebido
//         })
//     }
// }


// export function getDataInformacoes(CodPuxada,resellerID, codcet) {
//     return (dispatch) => {
//         axios.get(`${Baseurlaxios}/Customer/DadosInformacoes?CodPuxada=${CodPuxada}&resellerID=${resellerID}&codcet=${codcet}&CtrFin=false`, {
//             headers: {
//                 "Access-Control-Allow-Origin": "*",
//                 "Content-Type": "application/x-www-form-urlencoded"
//             },
//         })
//             .then(response => {
//                 dispatch({
//                     type: "GET_DATA_INFORMACOES",
//                     payload: response
//                 })
//             })
//             .catch(error => {
//                 toastr.error("Erro custumerActions getDataInformacoes: " + error)
//             })
//     };
// }